import React from "react"
import 'handsontable/dist/handsontable.full.min.css';
import Handsontable from 'handsontable/base';
import { registerAllModules } from 'handsontable/registry';
import { HotTable } from '@handsontable/react';
import { indexToLetter } from "../../utils/LanguageTableHelper";

export default function LanguageTable({ width = 'auto', tableData = [], setTableData }) {
console.log(tableData[0]);
    registerAllModules();
    let selectorLanguages = ['en', 'fr', 'ru', 'af', 'sq', 'am', 'ar', 'hy', 'as', 'ay', 'az', 'bm', 'eu', 'be', 'bn', 'bho', 'bs', 'bg', 'ca', 'ceb', 'zh', 'co', 'hr', 'cs', 'da', 'dv', 'doi', 'nl', 'en', 'eo', 'et', 'ee', 'fil', 'fi', 'fr', 'fy', 'gl', 'ka', 'de', 'el', 'gn', 'gu', 'ht', 'ha', 'haw', 'he', 'hi', 'hmn', 'hu', 'is', 'ig', 'ilo', 'id', 'ga', 'it', 'ja', 'jv', 'kn', 'kk', 'km', 'rw', 'gom', 'ko', 'kri', 'ku', 'ckb', 'ky', 'lo', 'la', 'lv', 'ln', 'lt', 'lg', 'lb', 'mk', 'mai', 'mg', 'ms', 'ml', 'mt', 'mi', 'mr', 'mni', 'lus', 'mn', 'my', 'ne', 'no', 'ny', 'or', 'om', 'ps', 'fa', 'pl', 'pt', 'pa', 'qu', 'ro', 'ru', 'sm', 'sa', 'gd', 'nso', 'sr', 'st', 'sn', 'sd', 'si', 'sk', 'sl', 'so', 'es', 'su', 'sw', 'sv', 'tl', 'tg', 'ta', 'tt', 'te', 'th', 'ti', 'ts', 'tr', 'tk', 'ak', 'uk', 'ur', 'ug', 'uz', 'vi', 'cy', 'xh', 'yi', 'yo', 'zu']
    return (
        <HotTable
            data={tableData}
            rowHeaders={false}
            colHeaders={['', ...Object.keys(tableData[0]).map((el) => {
                return indexToLetter(el)
            })]}
            colWidths={210}
            manualColumnResize={true}
            width={tableData.length !== 0 ? 210 * tableData[0].length : 210*2}
            afterRender={function () {
                const lastRow = this.countRows() - 1;
                const lastCol = this.countCols() - 1;

                // Color empty cells in the last row
                for (let col = 0; col <= lastCol; col++) {
                    const cellValue = this.getDataAtCell(lastRow, col);
                    const cell = this.getCell(lastRow, col);

                    if (!cellValue && cell) {
                        cell.style.background = '#f66d44';
                    } else if (cell) {
                        // Reset background color if cell is not empty
                        cell.style.background = '';
                    }
                }
                const lastRowHeader = this.getCell(lastRow, 0);
                // const lastRowHeader = container.querySelector(`${tableID} .handsontable tr:last-child td:first-child`);
                // const table = container.querySelector(`${tableID} .handsontable table`)
                // table.style = 'font-size: 13px'
                if (lastRowHeader) {
                    lastRowHeader.style = 'background: #673ab7; color: #FFF';
                }



            }}

            afterChange={function (changes, source) {




                // console.log(this.getData());
                const lastRow = this.countRows() - 1;

                if (source === 'edit') {
                    const newData = changes.map(([row, prop, oldValue, newValue]) => {
                        return [row, prop, newValue];
                    });

                    const up = (prevData) => {
                        const clonedData = [...prevData];
                        newData.forEach(([row, prop, newValue]) => {
                            clonedData[row][prop] = newValue;
                        });
                        return clonedData;
                    }

                    setTableData(up(tableData))

                    

                    // console.log(tableData);

                    // Check if the last edited cell in the last row is empty
                    const lastChange = changes[changes.length - 1];
                    const editedRow = lastChange[0];
                    const editedCol = lastChange[1];
                    const newValue = lastChange[3];

                    if (editedRow === lastRow && editedCol === this.countCols() - 1 && !newValue) {
                        const editedCell = this.getCell(editedRow, editedCol);
                        if (editedCell) {
                            editedCell.style.background = '#f66d44';
                        }
                    }
                }

                // Check and color empty cells in the last row after any change
                for (let col = 0; col < this.countCols(); col++) {
                    const cellValue = this.getDataAtCell(lastRow, col);
                    const cell = this.getCell(lastRow, col);

                    if (!cellValue && cell) {
                        cell.style.background = '#f66d44';
                    } else if (cell) {
                        // Reset background color if cell is not empty
                        cell.style.background = '';
                    }
                }
            }}


            afterCreateCol={function (index, amount) {
                var lastRow = this.countRows() - 1;
                var lastCol = index + amount - 1;

                // Устанавливаем значение по умолчанию XXX для всех ячеек в новом столбце последней строки
                this.setDataAtCell(lastRow, lastCol, 'XXX');
            }}

            //Запрет на редактирования ячейки с заголовком - "Значение"
            beforeChange={function (changes, source) {
                if (source === 'edit') {
                    for (const [row, col, oldValue, newValue] of changes) {
                        const lastRow = this.countRows() - 1;
                        if (row === lastRow && col === 0) {
                            return false;
                        }
                    }
                }
            }}
            //Рендер селекторов в первой колонке для выбора языка
            cells={function (row, col, prop) {
                if (col === 0) {
                    return {
                        editor: 'select',
                        selectOptions: selectorLanguages
                    };
                }
            }}
            //Запрет опций контекстного меню для разных ситуаций
            beforeContextMenuShow={function (menu) {
                const selectedRow = this.getSelectedLast()[0];
                const selectedCol = this.getSelectedLast()[1];

                const lastRow = this.countRows() - 1;
                const firstCol = 0;

                let AllMenuOptions = [
                    {
                        "key": "col_left",
                        "name": "Insert column left"
                    },
                    {
                        "key": "col_right",
                        "name": "Insert column right"
                    },
                    {
                        "key": "row_above",
                        "name": "Insert row above"
                    },
                    {
                        "key": "row_below",
                        "name": "Insert row below"
                    },
                    {
                        "key": "remove_row",
                        "name": "Remove row"
                    },
                    {
                        "key": "remove_col",
                        "name": "Remove column"
                    },
                    {
                        "key": "undo",
                        "name": "Undo"
                    },
                    {
                        "key": "redo",
                        "name": "Redo"
                    },
                    {
                        "key": "copy",
                        "name": "Copy",
                    },
                    {
                        "key": "cut",
                        "name": "Cut",
                        "hidden": false
                    }
                ]

                if (selectedRow === lastRow) {
                    menu.menu.menuItems = AllMenuOptions.filter((el) => !['row_below', 'cut', 'remove_row'].includes(el.key))
                }

                if (selectedCol === firstCol) {
                    menu.menu.menuItems = AllMenuOptions.filter((el) => !['col_left', 'cut', 'remove_col'].includes(el.key))
                }
                if (selectedCol === firstCol && selectedRow === lastRow) {
                    menu.menu.menuItems = AllMenuOptions.filter((el) => !['col_left', 'cut', 'remove_col', 'row_below', 'remove_row'].includes(el.key))
                }
            }}


            contextMenu={true}

            height={'auto'}
            licenseKey={'non-commercial-and-evaluation'}
        />
    )
}